import { combineReducers } from 'redux'
import { RECENT_SHIPMENTS_ACTION_TYPES } from 'utils/actions/shipments'
import carrierReducer from 'utils/reducers/carrier'
import childUsersReducer from 'utils/reducers/childUsers'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import logsReducer from 'utils/reducers/logs'
import mapboxReducer from 'utils/reducers/mapbox'
import notesReducer from 'utils/reducers/notes'
import shipmentsReducer, { makeShipmentsReducer } from 'utils/reducers/shipments'
import smsReducer from 'utils/reducers/sms'
import tagsReducer from 'utils/reducers/tags'
import userDriverLocationsReducer from 'utils/reducers/userDriverLocations'
import userProfileReducer from 'utils/reducers/userProfile'
import userCreateReducer from 'apps/user/utils/reducers/userCreateReducer'

const reducers = combineReducers({
  userProfile: userProfileReducer,
  recentShipments: makeShipmentsReducer(Object.keys(RECENT_SHIPMENTS_ACTION_TYPES)),
  shipments: shipmentsReducer,
  mapbox: mapboxReducer,
  userDriverLocations: userDriverLocationsReducer,
  logs: logsReducer,
  globalMessaging: globalMessagingReducer,
  notes: notesReducer,
  sms: smsReducer,
  carrier: carrierReducer,
  tags: tagsReducer,
  userCreate: userCreateReducer,
  childUsers: childUsersReducer,
})

export default reducers
